import { useState, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Banner from "./Component/Mobile/Dashboard/Banner/Banner";
import Chooseimg from "./Component/Mobile/Visualiser/Uploadimg/Chooseimg";
import CostmsingDoor from "./Component/Mobile/CustomisingDoor/CustomisingDoor";
import Customise from "./Component/Desktop/Customise";
import Home from "./Component/Desktop/Home";
import analyticsService from "./services/analyticsService";

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    
    // Initialize analytics
    analyticsService.initialize();
    
    // Debug analytics on app load (only in development)
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        console.log('Analytics Debug Info:', analyticsService.getDebugInfo());
      }, 3000); // Wait for analytics to load
    }
    
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <RouterProvider
      router={createBrowserRouter([
        {
          path: "/",
          element: <Banner /> ,
        },
        {
          path: "/visualiser",
          element:isMobile ?  <Chooseimg /> : <Home />,
        },
        {
          path: "/customise",
          element: <Customise />,
        },
        {
          path: "/customise_door",
          element: <CostmsingDoor />,
        },
      ])}
      key={isMobile}
    />
  );
}

export default App;
